import template from './traveller-profile-confirmation-message.html';

const DIRECTIVE_NAME = TravellerProfileConfirmationMessage.DIRECTIVE_NAME = 'ktTravellerProfileConfirmationMessage';
export default function TravellerProfileConfirmationMessage() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TravellerProfileConfirmationMessageController,
        controllerAs: '$ctrl',
        scope: {
            isProfileCreationMode: `=${DIRECTIVE_NAME}IsProfileCreationMode`,
            onSelect: `=${DIRECTIVE_NAME}OnSelect`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TravellerProfileConfirmationMessageController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/traveller-profile-confirmation-message/traveller-profile-confirmation-message-component.js